import { adminAPIService } from './index'

const route = 'hardcode-product'

export default {
  create(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  delete(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'delete',
    })
  },
}
